module.exports = function getResource(label, vars = []) {
    let resources = {
        privateContent: 'Private content',
        exploreAll: 'Explore all',
        viewAll: 'View all'
    };
    return resources[label];
};
